import { HomeIcon, ShieldIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { TypeTile } from "Components/Analyses/_Shared/TypeTile";
import { DebtIcon, FinancialSuccessIcon, HealthIcon, PiggyBankIcon, TargetIcon } from "Components/_Shared/Icons/Icons";
import { ExpenseLineExpenseType } from "Infrastructure/ApiZfp/Schema";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { FC } from "react";
import { EXPENSE_TYPE_TRANSLATION_KEY } from "../expenseTypes";

type Props = {
  readonly expenseType: ExpenseLineExpenseType;
  readonly disabled?: boolean;
};

const getIcon = (expenseType: ExpenseLineExpenseType) => {
  switch (expenseType) {
    case ExpenseLineExpenseType.housing:
      return <HomeIcon />;
    case ExpenseLineExpenseType.consumption:
      return <FinancialSuccessIcon />;
    case ExpenseLineExpenseType.life_style:
      return <HealthIcon />;
    case ExpenseLineExpenseType.loan:
      return <DebtIcon />;
    case ExpenseLineExpenseType["financial-product"]:
      return <PiggyBankIcon />;
    case ExpenseLineExpenseType.insurance:
      return <ShieldIcon />;
    case ExpenseLineExpenseType.other:
      return <TargetIcon />;
  }
};

// One expense type in the drawer's RadioGroup, the same tile as the other type pickers.
export const ExpenseTypeTile: FC<Props> = ({ expenseType, disabled = false }) => {
  const { t } = useResource();
  const icon = getIcon(expenseType);

  return (
    <TypeTile
      value={expenseType}
      disabled={disabled}
      icon={icon}
      label={t(Resources.AnalysisDetail.Budget.Expenses.ExpenseTypes[EXPENSE_TYPE_TRANSLATION_KEY[expenseType]])}
    />
  );
};
